import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {PermisoService} from '../permiso/permiso.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TipoSensorService} from './tipoSensor.service';
import {TipoSensor} from './tipoSensor';
import {LoginService} from '../login/login.service';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'tipoSensor',
    template: require('../../app/tipoSensor/tipoSensor.component.html'),
    styles: [require('../../app/tipoSensor/tipoSensor.component.css')]
})
export class TipoSensorComponent implements OnInit {
    tipoSensor: TipoSensor;
    idSeleccionado;
    active: any;
    active2: any;
    deshabilitar: boolean;
    permisos: any;

    constructor(private tipoSensorService: TipoSensorService,
                private permisoService: PermisoService,
                private loginService: LoginService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Perdir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("tipoSensor").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });

        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/tipoSensor/tipoSensorTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" :  "<span class=\"label label-danger\">Inactivo</span>"
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        })
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        //Inicializar
        this.tipoSensor = new TipoSensor();
        //Inicializar bandera deshabilitar
        this.deshabilitar = false;
    }

    ngOnDestroy() {
    }

    agregar() {
        //Inicializo variables
        this.tipoSensor = new TipoSensor();
        this.deshabilitar = false;
        $("#modalTipoSensor").modal("show");
        //Reseteo form para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    modificar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoSensor
                this.tipoSensorService
                    .getTipoSensor(this.idSeleccionado)
                    .subscribe(tipoSensor => {
                        this.tipoSensor = tipoSensor;
                    });
                this.deshabilitar = false;
                $("#modalTipoSensor").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoSensor
                this.tipoSensorService
                    .getTipoSensor(this.idSeleccionado)
                    .subscribe(tipoSensor => {
                        this.tipoSensorService.delete(tipoSensor).subscribe(() => $("#grid-data").bootgrid("reload"));

                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco tipoSensor
                this.tipoSensorService
                    .getTipoSensor(this.idSeleccionado)
                    .subscribe(tipoSensor => {
                        this.tipoSensor = tipoSensor;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                $("#modalTipoSensor").modal("show");

            }
        }
    }

    save() {

        this.tipoSensorService
            .save(this.tipoSensor)
            .subscribe((tipoSensor) => {
                this.tipoSensor = tipoSensor;
                //Inicializo variables
                this.tipoSensor = new TipoSensor();
                console.log(this.tipoSensor);
                //Ocultar modal
                $("#modalTipoSensor").modal("hide");
                //Reseteo formtipoSensor para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload");
            })
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/tipoSensor/tipoSensor.component.ts